// extracted by mini-css-extract-plugin
export default {"row":"viewBundle_row__SzUkG","col":"viewBundle_col__C4Dfx","card":"viewBundle_card__zapHv"};